export const CuepointReachedEvent = function (highlightId) {
  const eventName = 'cuepointReached';
  const event: Event & { highlightElementId?: string } = new Event(eventName);
  event.highlightElementId = highlightId;
  return event;
};
